export default __webpack_public_path__ + "static/media/slide-bg.49db01bc.png";